__turbopack_context__.v({
  "textBox": "ttz4rG_textBox",
  "wrapper": "ttz4rG_wrapper",
});
